import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidBedIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M7 12.5c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3Zm13-6h-8c-.6 0-1 .4-1 1v6H3v-8c0-.6-.4-1-1-1s-1 .4-1 1v13c0 .6.4 1 1 1s1-.4 1-1v-3h18v3c0 .6.4 1 1 1s1-.4 1-1v-9c0-1.7-1.3-3-3-3Z"/>
  </SvgIcon>
}

export default SolidBedIcon
